import React, { useEffect, useState } from "react"
import { Button, Col, Modal, ModalBody, Row } from "reactstrap"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../../hooks/useResponse"
import { assignContractToAdmin } from "../../../../api/contract"
import SearchSelectBox from '../../../../components/SearchSelectBox'
import { getAdminsPoolManagers} from '../../../../api/admins'
import ResultHandler from "../../../../components/ResultHandler"

const AssignAdminModal = ({handleClose, isOpen, contract, onSuccess}) => {
  const { t } = useTranslation()

  const {loading, error, setData: setAssign} = useResponse(assignContractToAdmin, () => {
    onSuccess()
    handleClose()
    
  })

  const [data, setData] = useState(null)

  useEffect(() => {
    if(contract?.admins?.length > 0){
      setData( contract.admins[0].id)
    }else{
      setData(null)
    }
  }, [contract])

  function handleSave(){

    setAssign({type: "add", data: {contractId: contract.id, data: {admins: [data]}}})
  }

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered={true}>
      <ModalBody className="py-5 px-5">
        <Row>
          <Col lg={12}>
            <div className="text-center mb-4">
              <h2>Assign Admin</h2>
              <p style={{fontSize: '15px'}}>
                This list only shows people that have the role 'Pool Manage' with the exact name.
              </p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <SearchSelectBox 
              api={getAdminsPoolManagers}
              type='admins'
              label='username'
              setValue={(v) => setData(v?.value)}
              
              value={data}
            />

            <ResultHandler error={error} />
          </Col>
          <Col>
            <div className="text-center mt-4">
              {!loading && <Button
                onClick={handleSave}
                color="primary"
                size="lg"
                style={{marginRight: "20px"}}
              >
                Save
              </Button>}
              {loading && <Button
                color="dark"
                size="lg"
                style={{marginRight: "20px"}}
              >
                Wait
              </Button>}
              <Button
                onClick={handleClose}
                color="dark"
                size="lg"
              >
                {t("btns.Cancel")}
              </Button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default AssignAdminModal
